module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [(_vm.component.type == 'hotel') ? _c('span', [_vm._v("Accommodatie:")]) : _vm._e(), _vm._v(" "), (_vm.component.type == 'ship') ? _c('span', [_vm._v("Hotelschip:")]) : _vm._e(), _vm._v(" "), (_vm.component.type == 'pickUp') ? _c('span', [_vm._v("Vervoer: ")]) : _vm._e(), _vm._v(_vm._s(_vm.component.name) + "\r\n          "), _c('i', {
    staticClass: "pull-right",
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.component.type == 'hotel') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Verzorgingstype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.care_type))])])]), _vm._v(" "), (_vm.component.address.toLowerCase() != 'n.v.t.') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Adres")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.address))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Stad")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.city))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Land")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.country))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.component.rooms), function(room) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(room.roomType) + " "), (room.occupation != room.capacity) ? _c('span', {
      staticClass: "sub-title"
    }, [_vm._v("Afwijkende bezetting van " + _vm._s(room.occupation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((room.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'ship') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Verzorgingstype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.care_type))])])]), _vm._v(" "), _vm._l((_vm.component.cabins), function(cabin) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(cabin.cabinType) + " "), (cabin.occupation != cabin.capacity) ? _c('span', {
      staticClass: "sub-title"
    }, [_vm._v("Afwijkende bezetting van " + _vm._s(cabin.occupation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((cabin.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'pickUp') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.transport_type))])])]), _vm._v(" "), _vm._l((_vm.component.locations), function(location) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v("Opstapplaats: " + _vm._s(location.startLocation) + " "), (location.startLocation != location.endLocation) ? _c('span', [_vm._v("| Uitstapplaats: " + _vm._s(location.endLocation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((location.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'activity' || _vm.component.type == 'arrangement') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.category))])])]), _vm._v(" "), _vm._l((_vm.component.options), function(option) {
    return _c('div', {
      staticClass: "card-partial"
    }, [(option.option_name !== 'Standaard') ? _c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(option.option_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((option.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7981d4fe"}!./src/templates/reservations/component-view.html
// module id = 546
// module chunks = 1